import { IconProps } from "./dto";

export function UserXIcon(props: IconProps) {
    return (
        <svg width={props.size} height={props.size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.3333 17.5V15.8333C13.3333 14.9493 12.9821 14.1014 12.357 13.4763C11.7319 12.8512 10.8841 12.5 10 12.5H4.16667C3.28261 12.5 2.43477 12.8512 1.80965 13.4763C1.18453 14.1014 0.833336 14.9493 0.833336 15.8333V17.5M15 6.66667L19.1667 10.8333M19.1667 6.66667L15 10.8333M10.4167 5.83333C10.4167 7.67428 8.92428 9.16667 7.08334 9.16667C5.24239 9.16667 3.75 7.67428 3.75 5.83333C3.75 3.99238 5.24239 2.5 7.08334 2.5C8.92428 2.5 10.4167 3.99238 10.4167 5.83333Z" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}